import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import {
  actions as loginActions,
  asyncActions as loginAsyncActions,
} from "../slices/loginSlice.js";
import { asyncActions as successAsyncActions } from "../slices/successSlice.js";
import {
  localStorageCredentialsIdentifier,
  localStorageUserIdentifier,
} from "../slices/loginSlice.js";
import lsActions from "../../utility/ls.js";

const listenerMiddleware = createListenerMiddleware();

const emailVerificationMethod = "EMAIL";
const phoneVerificationMethod = "MOBILE";

listenerMiddleware.startListening({
  matcher: isAnyOf(loginAsyncActions.login.fulfilled),
  effect: async (action, listenerApi) => {
    const OS = listenerApi.getState().systemState.OS;

    const isMailVerified =
      listenerApi.getState().loginState.login.userInfo.isMailVerified;
    const isPhoneVerified =
      listenerApi.getState().loginState.login.userInfo.isPhoneVerified;
    const loginMethod = listenerApi.getState().loginState.login.loginMethod;
    const result = JSON.parse(action.payload.P_RESULT);

    if (
      OS === "WEB" &&
      ((loginMethod === emailVerificationMethod && isMailVerified === true) ||
        (loginMethod === phoneVerificationMethod && isPhoneVerified === true))
    ) {
      lsActions.addToLs({
        key: localStorageUserIdentifier,
        value: {
          id: result.nb1,
          ci: result.vc8,
          loginMethod: result.vc5,
          token: result.vc7,
        },
      });
    }

    if (OS !== "WEB") {
      lsActions.addToLs({
        key: localStorageCredentialsIdentifier,
        value: {
          u: action.meta?.arg.username,
          p: action.meta?.arg?.password,
          ve: isMailVerified,
          vm: isPhoneVerified,
          lm: loginMethod,
        },
      });
    }
  },
});

listenerMiddleware.startListening({
  matcher: isAnyOf(loginAsyncActions.relogin.fulfilled),
  effect: async (action, listenerApi) => {
    const OS = listenerApi.getState().systemState.OS;

    const isMailVerified =
      listenerApi.getState().loginState.login.userInfo.isMailVerified;
    const isPhoneVerified =
      listenerApi.getState().loginState.login.userInfo.isPhoneVerified;
    const loginMethod = listenerApi.getState().loginState.login.loginMethod;
    const result = JSON.parse(action.payload.P_RESULT);

    if (
      OS === "WEB" &&
      ((loginMethod === emailVerificationMethod && isMailVerified === true) ||
        (loginMethod === phoneVerificationMethod && isPhoneVerified === true))
    ) {
      lsActions.addToLs({
        key: localStorageUserIdentifier,
        value: {
          id: result.nb1,
          ci: result.vc8,
          loginMethod: result.vc5,
          token: result.vc7,
        },
      });
    }
  },
});

listenerMiddleware.startListening({
  matcher: isAnyOf(loginAsyncActions.relogin.rejected),
  effect: async (action, listenerApi) => {
    if (action.error?.name !== "AbortError") {
      lsActions.removeFromLs({ key: localStorageUserIdentifier });
    }
  },
});

listenerMiddleware.startListening({
  matcher: isAnyOf(loginActions.logout),
  effect: async (action, listenerApi) => {
    const OS = listenerApi.getState().systemState.OS;
    if (OS === "WEB") {
      lsActions.removeFromLs({ key: localStorageUserIdentifier });
    }

    if (OS !== "WEB") {
      lsActions.removeFromLs({ key: localStorageCredentialsIdentifier });
    }
  },
});

listenerMiddleware.startListening({
  matcher: isAnyOf(loginAsyncActions.loginWithSocialNetwork.fulfilled),
  effect: async (action, listenerApi) => {
    const OS = listenerApi.getState().systemState.OS;
    const navigate = action.meta.arg?.navigate;

    if (OS === "WEB") {
      const result = JSON.parse(action.payload.P_RESULT);
      console.log(result);
      if (result.isSuccess === true) {
        if (result.vc1 === "noCustomer") {
          navigate("/register", {
            state: {
              isWithSocialNetwork: true,
              email: result.vc2,
              name: result.vc3,
              surname: result.vc4,
              socialNetworkId: result.vc5,
              socialNetworkType : result.vc6
            },
          });
        } else {
          navigate("/");
        }
      } else {
        navigate("/");
      }
    }

    if (OS !== "WEB") {
    }
  },
});

listenerMiddleware.startListening({
  matcher: isAnyOf(loginAsyncActions.checkCurrentVerificationStatus.fulfilled),
  effect: async (action, listenerApi) => {
    const OS = listenerApi.getState().systemState.OS;
    const isMailVerified =
      listenerApi.getState().loginState.login.userInfo.isMailVerified;
    const isPhoneVerified =
      listenerApi.getState().loginState.login.userInfo.isPhoneVerified;
    const loginMethod = listenerApi.getState().loginState.login.loginMethod;

    const oldState = listenerApi.getOriginalState();
    const newState = listenerApi.getState();

    const oldIsMailVerified = oldState.loginState.login.userInfo.isMailVerified;
    const newIsMailVerified = newState.loginState.login.userInfo.isMailVerified;

    const oldIsPhoneVerified =
      oldState.loginState.login.userInfo.isPhoneVerified;
    const newIsPhoneVerified =
      newState.loginState.login.userInfo.isPhoneVerified;

    // console.log("oldIsMailVerified", oldIsMailVerified);
    // console.log("newIsMailVerified", newIsMailVerified);

    // console.log("oldIsPhoneVerified", oldIsPhoneVerified);
    // console.log("newIsPhoneVerified", newIsPhoneVerified);

    const showSuccess = action.meta.arg?.showSuccess ?? true; //showSuccess je default true

    const dispatch = listenerApi.dispatch;
    const result = action.payload.items[0];

    if (showSuccess === true) {
      if (
        (oldIsMailVerified === false && newIsMailVerified === true) ||
        (oldIsPhoneVerified === false && newIsPhoneVerified === true)
      ) {
        dispatch(
          successAsyncActions.showAsyncSuccess({
            msg: "tokenVerificationSuccess",
          })
        );
      }
    }

    if (
      ((isMailVerified && loginMethod === emailVerificationMethod) ||
        (isPhoneVerified && loginMethod === phoneVerificationMethod)) &&
      OS === "WEB"
    ) {
      lsActions.addToLs({
        key: localStorageUserIdentifier,
        value: {
          id: newState.loginState.login.userInfo.id,
          ci: newState.loginState.login.userInfo.ci,
          loginMethod: newState.loginState.login.loginMethod,
          token: newState.loginState.login.token.token,
        },
      });
    }

    if (
      ((isMailVerified && loginMethod === emailVerificationMethod) ||
        (isPhoneVerified && loginMethod === phoneVerificationMethod)) &&
      OS !== "WEB"
    ) {
      console.log("radim");
      lsActions.updateLS({
        key: localStorageCredentialsIdentifier,
        value: { ve: isMailVerified, vm: isPhoneVerified },
      });
    }
  },
});

listenerMiddleware.startListening({
  matcher: isAnyOf(loginAsyncActions.register.fulfilled),
  effect: async (action, listenerApi) => {
    const dispatch = listenerApi.dispatch;
    const result = JSON.parse(action.payload.P_RESULT);

    const username = action.meta.arg?.email;
    const password = action.meta.arg?.password;
    const navigate = action.meta.arg?.navigate;
    const setErrorMsg = action.meta.arg?.setErrorMsg;
    const isWithSocialNetwork = action.meta.arg?.isWithSocialNetwork ?? false;

    if (result.isSuccess === true) {
      await dispatch(
        successAsyncActions.showAsyncSuccess({ msg: "registrationSuccess" })
      );
      if (isWithSocialNetwork === false || 1 === 1) {
        const loginResult = await dispatch(
          loginAsyncActions.login({
            username: username,
            password: password,
            isWithSocialNetwork: isWithSocialNetwork,
          })
        );

        console.log(loginResult);
      }

      if (navigate) {
        navigate("/");
      }
    } else {
      setErrorMsg(result.error);
    }
  },
});

listenerMiddleware.startListening({
  matcher: isAnyOf(loginAsyncActions.changePassword.fulfilled),
  effect: async (action, listenerApi) => {
    const dispatch = listenerApi.dispatch;
    const result = JSON.parse(action.payload.P_RESULT);
    const navigate = action.meta.arg.navigate;
    const OS = listenerApi.getState().systemState.OS;
    const setErrorMsg = action.meta.arg.setErrorMsg;

    if (result.isSuccess === true) {
      await dispatch(
        successAsyncActions.showAsyncSuccess({ msg: "passwordChangedSuccess" })
      );
      if (OS === "WEB") {
        navigate("/");
      } else {
        navigate("loginPageouter");
      }
    } else {
      setErrorMsg(result.error);
    }
  },
});

listenerMiddleware.startListening({
  matcher: isAnyOf(loginAsyncActions.verifyMailToken.fulfilled),
  effect: async (action, listenerApi) => {
    const dispatch = listenerApi.dispatch;
    const result = JSON.parse(action.payload.P_RESULT);
    const navigate = action.meta.arg.navigate;
    const setErrorMsg = action.meta.arg.setErrorMsg;

    if (result.isSuccess === true) {
      await dispatch(
        loginAsyncActions.relogin({ loginId: null, reloginId: null })
      );
      await dispatch(
        successAsyncActions.showAsyncSuccess({
          msg: "tokenVerificationSuccess",
        })
      );

      lsActions.addToLs({
        key: localStorageUserIdentifier,
        value: {
          id: result.nb1,
          ci: result.vc2,
          loginMethod: emailVerificationMethod,
          token: result.vc1,
        },
      });

      navigate("/");
    } else {
      setErrorMsg(result.error);
    }
  },
});

listenerMiddleware.startListening({
  matcher: isAnyOf(loginAsyncActions.generateChangePassToken.fulfilled),
  effect: async (action, listenerApi) => {
    const dispatch = listenerApi.dispatch;
    const result = JSON.parse(action.payload.P_RESULT);
    const navigate = action.meta.arg.navigate;
    const setErrorMsg = action.meta.arg.setErrorMsg;
    const setTokenRequested = action.meta.arg.setTokenRequested;
    const setTokenRequestMethod = action.meta.arg.setTokenRequestMethod;
    const pUserIdentifier = action.meta.arg.pUserIdentifier;
    const changeMethod = result.vc1;
    const OS = listenerApi.getState().systemState.OS;

    if (result.isSuccess === true) {
      const msg =
        changeMethod === "E"
          ? "changePasswordTokenCreated"
          : "changePasswordSmsTokenSent";

      setTokenRequestMethod(changeMethod);

      await dispatch(
        successAsyncActions.showAsyncSuccess({
          msg: msg,
        })
      );

      if (changeMethod === "E") {
        if (OS === "WEB") {
          navigate("/");
        } else {
          navigate("loginPageouter");
        }
      } else if (changeMethod === "S") {
        if (OS === "WEB") {
          navigate(
            `/forgotPasswordMobile?mobile=${encodeURIComponent(
              pUserIdentifier
            )}`
          );
        } else {
          navigate("forgotPasswordMobileouter", { pUserIdentifier });
        }
      }

      setTokenRequested(true);

      return true;
    } else {
      setErrorMsg(result.error);
      return false;
    }
  },
});

listenerMiddleware.startListening({
  matcher: isAnyOf(loginAsyncActions.sendMailVerificationAgain.fulfilled),
  effect: async (action, listenerApi) => {
    const dispatch = listenerApi.dispatch;
    const result = JSON.parse(action.payload.P_RESULT);

    if (result.isSuccess === true) {
      dispatch(
        successAsyncActions.showAsyncSuccess({ msg: "emailTokenSentAgain" })
      );
    }
  },
});

listenerMiddleware.startListening({
  matcher: isAnyOf(loginAsyncActions.sendSMSverificationAgain.fulfilled),
  effect: async (action, listenerApi) => {
    const dispatch = listenerApi.dispatch;
    const result = JSON.parse(action.payload.P_RESULT);

    if (result.isSuccess === true) {
      dispatch(
        successAsyncActions.showAsyncSuccess({ msg: "smsTokenSentAgain" })
      );
    }
  },
});

listenerMiddleware.startListening({
  matcher: isAnyOf(loginAsyncActions.verifySMStoken.fulfilled),
  effect: async (action, listenerApi) => {
    const OS = listenerApi.getState().systemState.OS;
    const dispatch = listenerApi.dispatch;
    const result = JSON.parse(action.payload.P_RESULT);

    const { setErrorMsg, closeModal, setVerificationAttempted } =
      action.meta.arg ?? {};

    setVerificationAttempted(true);

    if (result.isSuccess === true) {
      await dispatch(
        successAsyncActions.showAsyncSuccess({
          msg: "tokenVerificationSuccess",
        })
      );
      if (closeModal) {
        closeModal();
      }

      if (OS !== "WEB") {
        lsActions.updateLS({
          key: localStorageCredentialsIdentifier,
          value: { vm: true },
        });
      }
    } else {
      setErrorMsg(result.error);
      return false;
    }
  },
});

///////////////
listenerMiddleware.startListening({
  matcher: isAnyOf(loginAsyncActions.deactivateAccount.fulfilled),
  effect: async (action, listenerApi) => {
    const dispatch = listenerApi.dispatch;
    const result = JSON.parse(action.payload.P_RESULT);
    const setErrorMsg = action.meta.arg.setErrorMsg;

    if (result.isSuccess === true) {
      await dispatch(
        successAsyncActions.showAsyncSuccess({
          msg: "accountDeactivatedSucessfully",
        })
      );
      dispatch(loginActions.logout());
    } else {
      setErrorMsg(result.error);
    }
  },
});

export default listenerMiddleware;
